import { BaseCard } from './card';
import { withAccordionContext } from './contexts/accordion';
import { withErrorContext } from './contexts/error';

export * from './components';

export const FormCard = withErrorContext(BaseCard);
export const AccordionCard = withAccordionContext(FormCard);
